import { LOCATION } from '@/app/consts/location.ts';

export const NavigationLinks = [
  { label: 'footer.privacy-cookie', path: LOCATION.PRIVACY_POLICY },
  { label: 'footer.terms-of-use', path: LOCATION.TERMS_OF_USE }
];
